/*
 * @Author: Chao Yang
 * @Date: 2020-05-06 10:42:26
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-05-20 16:49:00
 */
import { InjectionToken } from '@angular/core';

export const CONFIG_DATA = new InjectionToken<{}>('DIALOG_CONFIG_DATA');
